<script>
import VDialog from 'vuetify/lib/components/VDialog';

export default {
  extends: VDialog,

  props: {
    overlayColor: {
      type: String,
      default: 'bnw900',
    },

    overlayOpacity: {
      type: [String, Number],
      default: 0.1,
    },
  },
};
</script>
